import React from "react";

import { UserEntityForm, UserFormProps } from "Bands/components";
import { useCleanFileOnSubmit, useValidateIssueExpiryDates } from "Bands/utils";
import { useProfileContext } from "Auth/contexts";

import { getFormFields } from "./formData";

export const UserSocialSecurityForm: React.FC<UserFormProps> = ({
  defaultValues,
  handleSubmit,
  ...rest
}) => {
  const { currentUser } = useProfileContext();

  const {
    handleExpiryDateChange,
    handleFutureExpiryDateChange,
    handleIssueDateChange,
    isExpiryInFuture,
    isIssueBeforeExpiry,
  } = useValidateIssueExpiryDates(defaultValues?.issueDate, defaultValues?.expiryDate);

  const { onSubmit } = useCleanFileOnSubmit({
    handleSubmit,
    userId: currentUser?.id,
    defaultFiles: defaultValues?.files,
  });

  return (
    <UserEntityForm
      defaultValues={defaultValues}
      handleSubmit={onSubmit}
      fields={getFormFields({
        isExpiryInFuture,
        isIssueBeforeExpiry,
        handleIssueDateChange,
        handleExpiryDateChange: date => {
          handleExpiryDateChange(date);
          handleFutureExpiryDateChange(date);
        },
      })}
      style={{ gridTemplateColumns: "1fr 1fr" }}
      {...rest}
    />
  );
};
